import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import {
  ActiveTimerResponse,
  PauseTimerRequest,
  ResumeTimerRequest,
  StartTimerRequest,
  StopTimerRequest,
  UpdateTimerRequest,
} from '../types/dto/active-timer.dto';
import { WorklogResponse } from '../types/dto/worklogs-summary.dto';

export const getActiveTimer = async (): Promise<ActiveTimerResponse | null> => {
  const endpoint = '/api/worklogs/timer';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_LOAD_FAILED, () =>
    axiosInstance.get<ApiResponse<ActiveTimerResponse | null>>(endpoint)
  );
};

export const startTimer = async (values: StartTimerRequest): Promise<ActiveTimerResponse> => {
  const endpoint = '/api/worklogs/timer/start';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_START_FAILED, () =>
    axiosInstance.post<ApiResponse<ActiveTimerResponse>>(endpoint, values)
  );
};

export const pauseTimer = async (values: PauseTimerRequest): Promise<ActiveTimerResponse> => {
  const endpoint = '/api/worklogs/timer/pause';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_PAUSE_FAILED, () =>
    axiosInstance.post<ApiResponse<ActiveTimerResponse>>(endpoint, values)
  );
};

export const resumeTimer = async (values: ResumeTimerRequest): Promise<ActiveTimerResponse> => {
  const endpoint = '/api/worklogs/timer/resume';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_RESUME_FAILED, () =>
    axiosInstance.post<ApiResponse<ActiveTimerResponse>>(endpoint, values)
  );
};

export const updateTimer = async (values: UpdateTimerRequest): Promise<ActiveTimerResponse> => {
  const endpoint = '/api/worklogs/timer';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_UPDATE_FAILED, () =>
    axiosInstance.patch<ApiResponse<ActiveTimerResponse>>(endpoint, values)
  );
};

export const stopTimer = async (values: StopTimerRequest): Promise<WorklogResponse | null> => {
  const endpoint = '/api/worklogs/timer/stop';

  return withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_STOP_FAILED, () =>
    axiosInstance.post<ApiResponse<WorklogResponse | null>>(endpoint, values)
  );
};

export const discardTimer = async (): Promise<void> => {
  const endpoint = '/api/worklogs/timer';

  await withApiErrorHandler(endpoint, ApiErrorCode.ACTIVE_TIMER_DISCARD_FAILED, () =>
    axiosInstance.delete<ApiResponse<void>>(endpoint)
  );
};
